<template>
  <div class="beta-info-page">
    <h2>内测说明</h2>
    <p class="lead">
      AIVideoClip 当前为 <strong>内测免费</strong> 阶段。主功能为「发现主播精彩」：上传长回放，智能发现精彩片段并预览下载。固定时长切片为可选工具，默认关闭。
    </p>

    <el-alert
      :title="freeQuotaNotice"
      type="warning"
      :closable="false"
      show-icon
      class="alert-block"
    />

    <el-alert
      title="视频文件默认保留 24 小时，请及时下载；正式收费前将提前公告。"
      type="info"
      :closable="false"
      show-icon
      class="alert-block"
    />

    <section>
      <h3>{{ agreementTitle }}</h3>
      <div v-for="section in agreementSections" :key="section.title" class="term-block">
        <h4>{{ section.title }}</h4>
        <p>{{ section.body }}</p>
      </div>
    </section>

    <section>
      <h3>{{ privacyTitle }}</h3>
      <div v-for="section in privacySections" :key="section.title" class="term-block">
        <h4>{{ section.title }}</h4>
        <p>{{ section.body }}</p>
      </div>
    </section>

    <section>
      <h3>问题反馈</h3>
      <p>登录后可通过页面右下角「反馈」按钮提交建议或问题，我们会在 Admin 后台查看。</p>
    </section>
  </div>
</template>

<script>
import {
  USER_AGREEMENT_TITLE,
  USER_AGREEMENT_SECTIONS,
  PRIVACY_NOTICE_TITLE,
  PRIVACY_NOTICE_SECTIONS,
} from '../constants/betaTerms';
import { FREE_QUOTA_BETA_NOTICE } from '../constants/freeQuotaNotice';

export default {
  name: 'BetaInfoPage',
  data() {
    return {
      freeQuotaNotice: FREE_QUOTA_BETA_NOTICE,
      agreementTitle: USER_AGREEMENT_TITLE,
      agreementSections: USER_AGREEMENT_SECTIONS,
      privacyTitle: PRIVACY_NOTICE_TITLE,
      privacySections: PRIVACY_NOTICE_SECTIONS,
    };
  },
};
</script>

<style scoped>
.beta-info-page {
  background: rgba(15, 23, 42, 0.55);
  border: 1px solid rgba(148, 163, 184, 0.2);
  border-radius: 10px;
  padding: 20px 22px;
}
h2 { margin: 0 0 10px; font-size: 20px; }
h3 { margin: 24px 0 10px; font-size: 16px; color: #e2e8f0; }
h4 { margin: 0 0 6px; font-size: 14px; color: #cbd5e1; }
.lead { color: #94a3b8; line-height: 1.6; margin: 0 0 16px; }
.alert-block { margin-bottom: 12px; }
.term-block { margin-bottom: 14px; }
.term-block p { margin: 0; color: #94a3b8; line-height: 1.65; font-size: 13px; }
section p { color: #94a3b8; line-height: 1.65; font-size: 13px; }
</style>
